var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_other_message"},_vm._l((_vm.productParams),function(item){return _c('div',{key:item.id,staticClass:"detail_other"},[_c('span',{staticClass:"detail_title"},[_vm._v(_vm._s(item.title)+"：")]),_vm._v(" "),_c('span',{staticClass:"detail_value"},[_vm._v(_vm._s(item.value))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15d21bc2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/basic_product_detail/components/params.vue
// module id = null
// module chunks = 